import { Component, OnInit } from '@angular/core';
import {commonService} from "../../service/common.service";
import { ecommerceService } from '../../service/ecommerce.service';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http'

@Component({
  selector: 'app-viewcategory',
  templateUrl: './viewcategory.component.html',
  styleUrls: ['./viewcategory.component.css'],
  providers:[commonService,ecommerceService]
})
export class ViewcategoryComponent implements OnInit {
  isError=false;
  msg:any;
  isSuccess=false;
  totalrow:number;
  searchtxt:string;
  notfound=false;
  pageSize = 10;
  currentPage = 0;
  start=0;
  end=10; 
  pageEvent: any;
  categorylist:any;
  constructor(public router: Router,private ecommerceService:ecommerceService,private commonService:commonService,private route: ActivatedRoute) { 
    this.route.queryParams.subscribe(params => {
      this.searchtxt=params['search'];
    });
  }

  ngOnInit() {
    this.getcategorylist();
    this.localstoragemmsg();
  }
  // paging handle
  handlePage(e: any){
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.end = this.pageSize;
    this.start = this.currentPage * this.pageSize;
    this.getcategorylist()    
  }

  getcategorylist(){
    this.ecommerceService.categorylist({0:this.start,1:this.end,2:this.searchtxt,3:this.commonService.user}).subscribe((data : any)=>{
            if(data.error==0){ 
              this.categorylist = data.results.rows;
              this.totalrow = data.results.count;
              if(this.totalrow==0){
                this.notfound=true;
              }else{
                this.notfound=false;
              }
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
               this.msg = data.message;
               this.isError = true;
              }
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });
  
}

filterform(searchtxt){
  var txt = searchtxt.value.search.trim();
  if(txt!=""){
  this.router.navigateByUrl('/admin/ecommerce/viewcategory?search='+txt);
  }else{
    this.router.navigateByUrl('/admin/ecommerce/viewcategory');
  }
  this.searchtxt=txt;
  this.getcategorylist();  
}
editcategory(Id){
 this.router.navigateByUrl('/admin/ecommerce/editcategory?cid='+btoa(Id));
}
delcategory(Id){

  
    if(window.confirm('Are sure you want to delete this Category ?')){
      this.ecommerceService.delcategory(Id).subscribe((data : any)=>{
        if(data.error==0){
          this.isSuccess=true;
          this.msg="Category has been deleted successfully!";
          this.getcategorylist()
        }else{
          this.isError = true;
          this.msg=data.error;
        }
    },
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    });
     }  
    

}


  localstoragemmsg(){
    if(localStorage.getItem('isSuccess')=="Yes"){
      this.isSuccess=true;
      this.msg =    localStorage.getItem('msg');
      localStorage.removeItem('isSuccess');
      localStorage.removeItem('msg');
    }
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/ecommerce/viewcategory/viewcategory.component.ts